import { lazy } from 'react';
import { RouteObject } from 'react-router';

import { IntegrationSystem } from '@/shared/types';

import { createSystemRoutes } from '@/router/utils';

import { BIA_ROUTES } from './config';

const Insurance = lazy(() => import('../pages/services/Insurance'));
const InsuranceOrders = lazy(() => import('../pages/InsuranceOrders'));

export const biaSystemComponents: Record<keyof typeof BIA_ROUTES, React.LazyExoticComponent<React.FC<any>>> = {
  INSURANCE: Insurance,
  INSURANCE_ORDERS: InsuranceOrders,
};

export const BiaRoutes: RouteObject = createSystemRoutes(IntegrationSystem.BIA, BIA_ROUTES, biaSystemComponents);
